

class ErrorMessage {

}
export default ErrorMessage;
